var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SimpleDataCard',{attrs:{"title":'Toplam B2B Sipariş Sayısı',"data":_vm.reportCompanyData.totalB2bOrder.toString(),"description":'Tüm Zamanlar',"loading":_vm.reportCompanyDataLoading,"route":"b2b-order-list"}})
}
var staticRenderFns = []

export { render, staticRenderFns }